/**
 * Heatmap shortcuts.
 */
import { Heatmaps } from "../../features/analytics/heatmaps";

export class HeatmapTracker {
  constructor(public readonly client: Heatmaps) {}

  /** Record a click point. */
  click(pageUrl: string, x: number, y: number, viewportWidth: number, viewportHeight: number) {
    return this.client.trackClick({ pageUrl, x, y, viewportWidth, viewportHeight });
  }

  /** Record a mouse-movement path. */
  movement(pageUrl: string, path: Array<{ x: number; y: number; t: number }>, viewport: { width: number; height: number }) {
    return this.client.trackMovement({ pageUrl, path, viewport });
  }

  /** Record scroll behaviour. */
  scroll(pageUrl: string, maxScrollDepth: number, pageHeight: number, viewportHeight: number) {
    return this.client.trackScroll({ pageUrl, maxScrollDepth, pageHeight, viewportHeight });
  }

  /** Auto-attach click + scroll listeners (and optionally mousemove). */
  autoTrack(options?: { movement?: boolean; userId?: string; sessionId?: string }) {
    return this.client.autoTrack(options);
  }
}
